import React, { Component } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import FilterListIcon from '@material-ui/icons/FilterList';
import DeviceFilterMenu from './DeviceFilterMenu.jsx';

function DeviceFilterButton({ selected, onClick }) {
  const classes = clsx({
    'map-btn': true,
    'map-btn--selected': selected,
  });

  return (
    <a id="mapDeviceFilterMenuBtn" className={classes}
      onClick={onClick}>
      <FilterListIcon />
    </a>
  );
}

class DeviceFilterControls extends Component {
  state = {
    deviceFilterMenuAnchor: null,
  };

  handleDeviceFilterToggle = (event) => {
    this.setState({
      deviceFilterMenuAnchor: this.state.deviceFilterMenuAnchor ? null : event.currentTarget,
    });
  }

  handleDeviceFilterClose = () => {
    this.setState({
      deviceFilterMenuAnchor: null,
    });
  }

  render() {
    const { selected, options } = this.props;

    return (
      <div>
        <DeviceFilterButton
          selected={selected}
          onClick={this.handleDeviceFilterToggle} />

        <DeviceFilterMenu
            options={options}
            open={Boolean(this.state.deviceFilterMenuAnchor)}
            anchorEl={this.state.deviceFilterMenuAnchor}
            onChange={this.props.onChange}
            onClose={this.handleDeviceFilterClose} />
      </div>
    );
  }
}

DeviceFilterControls.propTypes = {
  selected: PropTypes.bool,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default DeviceFilterControls;
